import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { urlConfig } from '../../config';
import { useAppContext } from '../../context/AuthContext';

const Profile = () => {
  const [userDetails, setUserDetails] = useState({});
  const [updatedDetails, setUpdatedDetails] = useState({});
  const { setUserName } = useAppContext();
  const [changed, setChanged] = useState("");
  const [editMode, setEditMode] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const authtoken = sessionStorage.getItem("auth-token");
    if (!authtoken) {
      navigate("/app/login");
    } else {
      const email = sessionStorage.getItem("email");
      const name = sessionStorage.getItem('name');
      const storedUserDetails = { name, email };
      setUserDetails(storedUserDetails);
      setUpdatedDetails(storedUserDetails);
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const authtoken = sessionStorage.getItem("auth-token");
      const email = sessionStorage.getItem("email");
      if (!authtoken || !email) {
        navigate("/app/login");
        return;
      }

      const response = await fetch(`${urlConfig.backendUrl}/api/auth/update`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'email': email,
          'Authorization': `Bearer ${authtoken}`
        },
        body: JSON.stringify({ ...updatedDetails })
      });

      if (response.ok) {
        setUserName(updatedDetails.name);
        sessionStorage.setItem('name', updatedDetails.name);
        setUserDetails(updatedDetails);
        setEditMode(false);
        setChanged("Profile updated successfully!");
        setTimeout(() => {
          setChanged("");
          navigate("/app");
        }, 1500);
      } else {
        throw new Error("Failed to update profile");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const initials = userDetails.name
    ? userDetails.name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()
    : '?';

  return (
    <div className="profile-page">
      <div className="profile-card">
        <div className="profile-avatar">{initials}</div>

        {editMode ? (
          <form onSubmit={handleSubmit}>
            <div className="auth-field">
              <label>Email</label>
              <input type="email" value={userDetails.email || ''} disabled />
            </div>
            <div className="auth-field">
              <label>Name</label>
              <input
                type="text"
                name="name"
                value={updatedDetails.name || ''}
                onChange={(e) => setUpdatedDetails({ ...updatedDetails, name: e.target.value })}
                required
              />
            </div>
            <div className="profile-actions">
              <button type="submit" className="btn-gift btn-gift-primary">Save Changes</button>
              <button type="button" className="btn-gift btn-gift-secondary" onClick={() => setEditMode(false)}>Cancel</button>
            </div>
          </form>
        ) : (
          <>
            <h1>Hi, {userDetails.name}</h1>
            <p className="profile-email">{userDetails.email}</p>
            <div className="profile-actions">
              <button className="btn-gift btn-gift-primary" onClick={() => setEditMode(true)}>Edit Profile</button>
              <button className="btn-gift btn-gift-secondary" onClick={() => navigate('/app')}>Back to Gifts</button>
            </div>
          </>
        )}

        {changed && <p className="profile-success">{changed}</p>}
      </div>
    </div>
  );
};

export default Profile;
